import type { Program } from 'models';
import { Button, Col, Row, Title } from 'ui';
import { ProgramDescriptionContent } from './program-description-content';

type P = {
  isLearnMoreOpened: boolean;
  onLearnMore: () => void;
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramDescription = ({ isLearnMoreOpened, onLearnMore, program }: P) => (
  <Row className="program-description" gutter={[0, 'ms']}>
    <Col span={24}>
      <Title level={4}>Overview</Title>
    </Col>
    <ProgramDescriptionContent program={program} />
    {isLearnMoreOpened ? null : (
      <Col span={24}>
        <Button onClick={onLearnMore}>Learn More</Button>
      </Col>
    )}
  </Row>
);

export default ProgramDescription;
